export default "__VITE_PUBLIC_ASSET__49308b18__"